import { isEmpty } from 'lodash-es';

const { __ } = wp.i18n;
const { withSelect, select } = wp.data;
const { TextareaControl } = wp.components;
const { compose } = wp.compose;
const { Fragment } = wp.element;

const I18N_DOMAIN = 'ib-podcast';

const DisplayComponent = ({ meta, postType }) => {
	const postTypes = ['wow_podcast'];

	if (isEmpty(postType) || !postTypes.includes(postType)) {
		return null;
	}

	let podcastDescription = meta?.podcast_description ? meta?.podcast_description : '';

	const updateMeta = metaKey => value => {
		wp.data.dispatch('core/editor').editPost({
			meta: {
				...meta,
				[metaKey]: value,
			},
		});
	};

	const setPodcastDescription = e => {
		podcastDescription = e;
		updateMeta('podcast_description')(podcastDescription);
	};

	return (
		<Fragment>
			<>
				{
					<div>
						<TextareaControl
							label={__('Short Description', I18N_DOMAIN)}
							placeholder={__('Short Description', I18N_DOMAIN)}
							onChange={value => setPodcastDescription(value)}
							value={podcastDescription}
						/>
					</div>
				}
			</>
		</Fragment>
	);
};

export default compose(
	withSelect(() => {
		const meta = select('core/editor').getEditedPostAttribute('meta');
		const currentPost = select('core/editor').getCurrentPost();
		return {
			meta,
			postType: currentPost?.type,
		};
	}),
)(DisplayComponent);
